var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "card-box",
      on: {
        click: function ($event) {
          return _vm.goDetail()
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "card-pic" },
        [
          _c("div", { staticClass: "tips-tag", class: _vm.statusColor }, [
            _vm._v(_vm._s(_vm.tag)),
          ]),
          _c("el-image", {
            staticClass: "cover-photo",
            attrs: { src: _vm.cardData.live_cover, fit: "cover" },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "card-title" }, [
        _c("h3", [_vm._v(_vm._s(_vm.cardData.title))]),
      ]),
      _c("div", { staticClass: "time-info" }, [
        _c("i", { staticClass: "el-icon-time" }),
        _c("span", [_vm._v(_vm._s(_vm.cardData.live_time))]),
        _c("span", { staticClass: "view" }, [
          _c("i", { staticClass: "el-icon-view" }),
          _vm._v(" " + _vm._s(_vm.cardData.view_count)),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }